import { render } from "./SearchableContainer.vue?vue&type=template&id=5bd11e97&scoped=true"
import script from "./SearchableContainer.vue?vue&type=script&lang=js"
export * from "./SearchableContainer.vue?vue&type=script&lang=js"

import "./SearchableContainer.vue?vue&type=style&index=0&id=5bd11e97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd11e97"]])

export default __exports__